import { z } from 'zod';

export const EmailAttachmentSchema = z.object({
    attachmentId: z.number(),
    emailId: z.number(),
    fileName: z.string()
});

export type EmailAttachment = z.infer<typeof EmailAttachmentSchema>;